module.exports = "/_next/static/images/53bf03a554b9ef2cf04c261bb79ba732-product-information-xs-1x.jpg.webp";